import { Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';

@Component({
  selector: 'pt-custom-tooltip',
  templateUrl: './custom-tooltip.component.html',
  styleUrls: ['./custom-tooltip.component.scss']
})
export class CustomTooltipComponent implements ITooltipAngularComp {
  public text: string;
  private params: { field: string } & ITooltipParams;
  private MIN_LEN = 100;

  agInit(params: { field: string } & ITooltipParams): void {
    this.params = params;
    const row = params.api.getDisplayedRowAtIndex(params.rowIndex)?.data;
    if (row && row.toString().length > this.MIN_LEN) {
      const t = row[params.field];
      if (t !== null && t !== undefined) {
        this.text = t;
      }
    }
  }

}
